import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import forms from './appData'
import settings from './settings'
import library from './library'
import { getDefaultFormFields } from '@/utils/defaultFormData'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		settings,
		forms,
		library,
	},
	state: {
		instances: [],
		instance: null,
		hives: [],
		cats: [],
		uploadDialog: false,
		folders: [],
		files: {},
		currentFolder: '/',
		theApp: {},
		featureStates: {},
		formType: 'All Form/Survey Templates',
		prevRoute: '/',
		rightbar: '',
		save: '',
		search: {
			form: {}
		},

		currentForm: {
			leadScore: 1,
			name: '',
			type: '',
			group: '',
			pageButtons: [],
			url: '',
			instance: '',
			tags: [],
			fields: getDefaultFormFields(),
			lastRegistered: 0,
			users: [],
			options: {
				feedChildren: true,
				submitLabel: 'Submit',
				thanks: {
					headline: '',
					text: ''
				},
				supporting: '',
				consent: {
					enabled: true,
					text: 'I consent.'
				},
				smsConsent: {
					enabled: false,
					text: 'By submitting this form and signing up for texts, you consent to receive marketing text messages from [company name] at the number provided. Consent is not a condition of purchase. Msg & data rates may apply.'
				},
				taskNotification: {
					autoInitiate: false,
					users: [],
					title: '',
					description: '',
					taskPriority: 'low',
					taskType: '',
					daysDue: 0
				},
				autoresponder: '',
				autoresponderSubject: '',
				autoresponderPreheader: '',
				fromEmail: ''
			}
		},
		fileStructure: []
	},
	mutations: {
		SET_FILE_STRUCTURE(state, data) {
			state.fileStructure = data;
		},
		PREVIOUS_ROUTE(state, data) {
			state.prevRoute = data
		},
		SEARCH_SELECT(state, data) {
			state.search.form = data
		},
		OPEN_RIGHT_BAR(state, data) {
			state.rightbar = data
		},
		CLOSE_RIGHT_BAR(state) {
			state.rightbar = ''
		},
		FORM_TYPE(state, data) {
			state.formType = data.value
		},
		PAGE_BUTTONS(state, buttons) {
			state.pageButtons = buttons
		},
		OPEN_FORM_PAGE(state, data) {
			// state.formType = 'Add New Form'
			state.currentForm = data
		},
		OPEN_EDIT_FORM_PAGE(state, data) {
			// state.formType = 'Edit Form'
		},
		SET_APP(state, data) {
			state.theApp = data
		},
		SET_FEATURE_STATES(state, data) {
			state.featureStates = data
		},
		cancelUpload: (state) => {
			state.uploadDialog = false
		},
		uploadDialog: (state, folders = []) => {
			state.uploadDialog = true
			state.folders = folders
		},
		SET_INSTANCE: (state, data) => {
			state.instance = data
			state.cats = data.activeApps
		},
		SET_INSTANCES: (state, data) => {
			state.instances = data
		}

	},
	getters: {
		hasWorksheetAppAccess(state) {
			return !!state.instance?.apps?.find(app => app.subdomain === "worksheets");
		},
	},
	actions: {



	},
})
